import * as React from 'react';
import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/style';
import { ButtonAction } from '../Button';
import { Byline, Heading1 } from '../Text';
import { IDamImage, IMidPageCampaign } from '../../models/content.interfaces';
import { withMedia } from 'react-media-query-hoc';
import { ResponsiveImage } from '../Image';

const BannerH1 = Heading1.extend`
  margin: 0 0 24px 0;
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    margin: 0 0 32px 0;
  }
`.withComponent('h2');

const MidPageCompaignContainer = styled.section`
  padding: 32px 16px 0px 16px;
  box-sizing: border-box;
  max-width: 1140px;
  justify-content: center;
  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    align-items: center;
    display: flex;
    padding: 0px 0px;
    height: auto;
  }

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    justify-content: flex-start;
  }
`;

const MidPageCampaignInner = styled.div`
  display: inline-block;
  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    margin-left: 8px;
    width: 50%;
    padding: 32px 0;
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    margin-left: 16px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    margin-left: 0px;
    padding: 48px 0;
  }
`;

const MidPageCampaignInner2 = styled.div`
  display: inline-block;
  // margin: 0 auto;

  margin-top: 24px;
  margin-bottom: 32px;
  box-sizing: border-box;

  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    width: 50%;
    margin: 0 8px 0 32px;
    padding: 32px 0;
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    margin: 0 16px 0 32px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    margin-left: 64px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.LG}) {
    margin-right: 0px;
    padding-right: 16px;
  }
`;

const ByLineContainer = styled.div`
  margin-bottom: 16px;
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    margin-bottom: 24px;
  }
`;
interface mediaProps {
  mobile: boolean;
  xlarge: boolean;
  large: boolean;
  tablet: boolean;
  desktop: boolean;
}

interface DigitalAdoptionPureProps {
  bannerImage: IDamImage;
  bannerImageTitle: string;
  bannerImageAlt: string;
  headline: string;
  byline: string;
  buttonText: string;
  buttonLink: string;
  media: mediaProps;
}

const DigitalAdoptionPure = withMedia(
  ({
    headline,
    byline,
    buttonText,
    buttonLink,
    bannerImage,
    bannerImageAlt,
    bannerImageTitle,
  }: DigitalAdoptionPureProps) => (
    <MidPageCompaignContainer data-comment="MidPageCampaignContainer">
      <MidPageCampaignInner>
        <ResponsiveImage
          image={bannerImage}
          imageWidths={[425, 850, 1100]}
          sizes={{ XS: '343px', SM: '359px', MD: '464px', LG: '530px' }}
          alt={bannerImageAlt}
          title={bannerImageTitle}
          width={'100%'}
        />
      </MidPageCampaignInner>
      <MidPageCampaignInner2>
        <BannerH1>{headline}</BannerH1>

        <ByLineContainer>
          <Byline>{byline}</Byline>
        </ByLineContainer>

        <ButtonAction tracking="lets-get-moving" href={buttonLink}>
          {buttonText}
        </ButtonAction>
      </MidPageCampaignInner2>
    </MidPageCompaignContainer>
  ),
);

export class MidPageCampaign extends React.Component<IMidPageCampaign> {
  constructor(props: any, state: any) {
    super(props, state);
  }

  componentDidMount() {}

  render() {
    return <DigitalAdoptionPure data-comment="MidPageCampaign" {...this.state} {...this.props} />;
  }
}
